import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import common from './modules/common'
import temp from './modules/temp'

import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        user,
        common,
        temp
    },
    strict: debug,
    plugins: [createPersistedState({
        storage: window.localStorage,
        reducer(data) {
            return {
                user: data.user,
                common: data.common
            }
        }
    })]

})


// WEBPACK FOOTER //
// ./src/store/index.js